import { Brick, registerBrick } from 'olympe';

export default class SetInSessionStorage extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} key
     * @param {string} value
     * @param {!Array} outputs
     */
    update($, [key, value], outputs) {
        sessionStorage.setItem(key, value)
    }
}

registerBrick('019eda35532c2409cf31', SetInSessionStorage);
